import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'

// Initialize Firebase
firebase.initializeApp({
  apiKey: 'AIzaSyDCYy_4FXIEPEn3YAZMa0r8H8JP6mc13G8',
  authDomain: 'eos-detective.firebaseapp.com',
  databaseURL: 'https://eos-detective.firebaseio.com',
  projectId: 'eos-detective',
  storageBucket: 'eos-detective.appspot.com',
  messagingSenderId: '293696030724'
})

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const functions = firebase.functions()
const providerGoogle = new firebase.auth.GoogleAuthProvider()
const providerGithub = new firebase.auth.GithubAuthProvider()

export {
  db,
  auth,
  providerGoogle,
  providerGithub,
  functions
}
